import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { getMemberProfile } from '../../../core/api/user.api';
import { getDataFromResponse } from '../../../core/constant/utils/react-query-utils/getDataFromResponse';
import { normalizeUserData } from '../../../core/constant/utils/transformUserData';
import { setBasicInfo } from '../../../core/store/slices/basicInfoSlice';
import { setPersonalDetails } from '../../../core/store/slices/personalDetailsSlice';
import { setAvailability } from '../../../core/store/slices/availabilitySlice';
import { setEmergencyContact } from '../../../core/store/slices/emergencyContactSlice';
import { setPreferenceInformation } from '../../../core/store/slices/preferenceInformationSlice';
import { setMemberSubscription } from '../../../core/store/slices/memberSubscriptionSlice';

export const useProfileQuery = (enabled = false) => {
  const dispatch = useDispatch();
  
  return useQuery(
    ['memberProfile'],
    async () => {
      const response = await getMemberProfile();
      const data = getDataFromResponse(response);
      return data;
    },
    {
      enabled,
      onSuccess: (data) => {
        if (data && data.user) {
          const {
            basicInfo,
            personalDetails,
            preferenceInformation,
            availability,
            emergencyContact,
            subscription
          } = normalizeUserData(data.user, data.subscription, data.hash);
  
          dispatch(setBasicInfo(basicInfo));
          dispatch(setPersonalDetails(personalDetails));
          dispatch(setPreferenceInformation(preferenceInformation));
          dispatch(setAvailability(availability));
          dispatch(setEmergencyContact(emergencyContact));
          dispatch(setMemberSubscription(subscription))
        }
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    }
  );
};